import Grid from '@material-ui/core/Grid';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme, ThemeOptions } from '@material-ui/core';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import React from 'react';
import { useDispatch } from 'react-redux';

import { baseTheme } from '../../../theme';
import GroupItems from '../group-items';
import LeaderIcon from '../leader-icon';
import { loadFollowedLeaderGroups } from '../../../store/leaders/actions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0),
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(1),
    },
    accordion: {
      width: '100%',
      backgroundColor: '#ededed',
    },
    detailsSpace: {
      backgroundColor: theme.palette.background.paper,
    },
    content: {
      height: theme.spacing(5),
    },
    text: {
      fontWeight: 'bold',
      fontSize: '1.4em',
    },
  }),
);

const enhanceTheme = (theme: ThemeOptions) => Object.assign(theme, {
  ...theme.overrides,
  overrides: {
    MuiAccordionSummary: {
      content: {
        display: 'flex',
        alignItems: 'center',
      },
    },
  },
});

export default function FollowedItem(props: any) {
  const { leader: { id, name = '', displayName = '' , photoUrl = '/not-working.jpg' },
    allGroups = [], loaded = false } = props;
  const classes = useStyles(enhanceTheme(baseTheme));
  const dispatch = useDispatch();

  const leaderData = {
    id,
    name,
    displayName,
  };

  const onExpanded = (id: string) => async (event: any) => {
    loadFollowedLeaderGroups(id, dispatch);
  };

  return (
    <Grid item container className={classes.root} xs={12}>
      <Accordion
        className={classes.accordion}
        TransitionProps={{ unmountOnExit: true }}
        onChange={onExpanded(id)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="Leader Groups"
          id="leaderId-header"
          className={classes.content}
        >
          <LeaderIcon
            displayName={name}
            avatarImg={photoUrl}
            size="small"
            isSelected={false} />
          <Typography variant="body1" className={classes.text}>
            {displayName}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.detailsSpace}>
          <Grid item container direction="column">
            {loaded && allGroups?.length && allGroups.map(
              (group: any) => (
                <GroupItems
                  {...group}
                  leader={leaderData}
                />
              ),
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
